export var mapFashionPreference = function (source) {
    if ((source === null || source === void 0 ? void 0 : source.toLocaleLowerCase()) === 'mens')
        return 'MALE';
    if ((source === null || source === void 0 ? void 0 : source.toLocaleLowerCase()) === 'womens')
        return 'FEMALE';
    return undefined;
};
